import React, { useState } from 'react'
import axios from 'axios'
import { Modal, message, Button } from 'antd'
import MyInput from '../../../components/forms/input'
import MyTextArea from '../../../components/forms/textArea'

const AddChatbotKnowledge = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  const handleSubmit = () => {
    setErrorMsg({})
    if (!formValue.question) {
      setErrorMsg({questionEmpty: '问题不能为空'})
      return false
    }
    if (!formValue.answer) {
      setErrorMsg({answerEmpty: '答案不能为空'})
      return false
    }
    if (!formValue.scene_name) {
      setErrorMsg({sceneEmpty: '场景不能为空'})
      return false
    }
    if (!formValue.category_name) {
      setErrorMsg({categoryEmpty: '类目不能为空'})
      return false
    }

    axios.post('/p/chatbot/knowledge/add', {
      merchant_oid: merchantOid,
      question: formValue.question,
      answer: formValue.answer,
      scene_name: formValue.scene_name,
      category_name: formValue.category_name
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('新知识库问题创建成功！')
          props.getKnowledgeData()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleOk = () => {
    const isOk = handleSubmit()
    if (isOk !== false) {handleCancel()}
  }

  const handleNext = () => {
    handleSubmit()
    setFormValue({})
  }

  const handleCancel = () => {
    setErrorMsg({})
    setFormValue({})
    props.isCancel()
  }

  return (
    <>
      <Modal
        destroyOnClose={true}
        title="添加知识库问题"
        width='600px'
        open={props.isOpen}
        onCancel={handleCancel}
        maskClosable={false}
        footer={[
          <Button key='cancel' onClick={handleCancel}>取消</Button>,
          <Button key='submit' onClick={handleNext}>提交并新建下一条</Button>,
          <Button key='isOk' type="primary" onClick={handleOk}>创建</Button>
        ]}>

        <MyInput
          id="question"
          required
          autoFocus
          maxLength={64}
          label='问题'
          placeholder='请输入'
          value={formValue.question}
          onChange={setFormValue}
          errorMsg={errorMsg.questionEmpty}
        />

        <MyTextArea
          id="answer"
          required
          label='答案'
          minRows={3}
          placeholder='请输入完整的答案'
          value={formValue.answer}
          onChange={setFormValue}
          errorMsg={errorMsg.answerEmpty}
        />

        <MyInput
          id="scene_name"
          required
          autoFocus
          maxLength={64}
          label='场景'
          placeholder='请输入'
          value={formValue.scene_name}
          onChange={setFormValue}
          errorMsg={errorMsg.sceneEmpty}
        />

        <MyInput
          id="category_name"
          required
          autoFocus
          maxLength={64}
          label='类目'
          placeholder='请输入'
          value={formValue.category_name}
          onChange={setFormValue}
          errorMsg={errorMsg.categoryEmpty}
        />
      </Modal>
    </>
  )
}

export default AddChatbotKnowledge
